import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoldIcon, WarningBoldIcon } from '@pattern-library/icon';
const propTypes = {
  /**
   * Message to display in the feedback message
   */
  children: PropTypes.node,
  /**
   * Class for the feedback message container
   */
  className: PropTypes.string,
  /**
   * Icon to display in the feedback message
   */
  icon: PropTypes.elementType,
  /**
   * The severity of the feedback message
   */
  level: PropTypes.oneOf(['error', 'warning'])
};
function FeedbackMessage(_ref) {
  let {
    children,
    level = 'error',
    icon,
    className = ''
  } = _ref;
  const defaultIcon = level === 'error' ? ErrorBoldIcon : WarningBoldIcon;
  const Icon = icon ?? defaultIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: `asc-form-help is-${level} ${className}`
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "asc-form-help-icon",
    customSize: "14px",
    color: level
  }), /*#__PURE__*/React.createElement("p", {
    className: "asc-form-help--error-message"
  }, children));
}
FeedbackMessage.propTypes = propTypes;
export default FeedbackMessage;